import { render } from "./MarketingTile.vue?vue&type=template&id=64262605"
import script from "./MarketingTile.vue?vue&type=script&lang=js"
export * from "./MarketingTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__